import React from "react";

const reviews = [
  {
    id: 1,
    name: "Sarah Johnson",
    avatar: "/paywall_review_1.jpg", // You'll need to add these images
    text: "This app completely changed my approach to healthy eating. Lost 15 pounds in 2 months! The meal plans are super easy to follow.",
  },
  {
    id: 2,
    name: "Michael Chen",
    avatar: "/paywall_review_2.jpg",
    text: "Best investment in my health journey. The personalized recommendations and tracking features are incredible. Highly recommend!",
  },
  {
    id: 3,
    name: "Emma Wilson",
    avatar: "/paywall_review_3.jpg",
    text: "I've tried many nutrition apps before, but this one is different. It's intuitive, accurate, and the results are amazing.",
  },
];

export function CustomerReviews() {
  return (
    <div className="mt-8 space-y-4">
      <h4 className="text-center font-bold text-xl text-gray-800 mb-6">
        Trusted by Thousands
      </h4>
      {reviews.map((review) => (
        <div
          key={review.id}
          className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm
                      transform transition-all duration-200 hover:shadow-md"
        >
          <div className="flex items-center mb-2">
            <img
              src={review.avatar}
              alt={review.name}
              className="w-10 h-10 rounded-full mr-3"
            />
            <div>
              <div className="font-bold">{review.name}</div>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-4 h-4 text-green-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>
          </div>
          <p className="text-gray-500 text-sm">{review.text}</p>
        </div>
      ))}
    </div>
  );
}
